import { CognitoUser, CognitoUserAttribute, CognitoUserPool, CognitoUserSession } from 'amazon-cognito-identity-js';
import UserPool from './UserPool';
import { parseUserData } from '../../../views/profile/util';

class UserCognitoService {
  public cognitoUser?: CognitoUser;

  constructor(private pool: CognitoUserPool) {
    const user = pool.getCurrentUser();
    if (!user) {
      this.logout();
      return;
    }
    user.getSession((err: Error, session: CognitoUserSession | null) => {
      if (err || !session?.isValid()) return this.logout();
      this.cognitoUser = user;
      if (window.location.pathname === '/login') {
        window.location.replace('/');
      }
    });
  }

  getUserAttributes = async () =>
    new Promise((resolve, reject) => {
      if (this.cognitoUser) {
        this.cognitoUser.getUserAttributes((err: any, data: any) => {
          if (err) {
            console.log(JSON.stringify(err));
            if (err === 'UserNotFoundException: User does not exist.') {
              localStorage.clear();
            }
            reject(err);
          } else {
            resolve(parseUserData(data));
          }
        });
      } else {
        this.logout();
      }
    });

  updateUser = async (attributes: CognitoUserAttribute[]) =>
    new Promise((resolve, reject) => {
      if (this.cognitoUser) {
        this.cognitoUser.updateAttributes(attributes, (err, result, detail) => {
          if (err) {
            reject(err);
          } else {
            resolve(result);
          }
        });
      } else {
        this.logout();
      }
    });

  changePassword = async (password: string, newPassword: string) =>
    new Promise((resolve, reject) => {
      if (this.cognitoUser) {
        this.cognitoUser.changePassword(password, newPassword, (err, result) => {
          if (err) {
            reject(err);
          } else {
            resolve(result);
          }
        });
      } else {
        this.logout();
      }
    });

  logout = () => {
    if (this.cognitoUser) {
      console.log('>>> Logout');

      this.cognitoUser.signOut();
      const lang = localStorage.getItem('i18nextLng');

      localStorage.clear();
      if (lang) {
        localStorage.setItem('i18nextLng', lang);
      }
      window.location.reload();
    }
  };
}

export default new UserCognitoService(UserPool);
